import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as Email from "email-validator";
import Password from "../common/password-validator";
import apiRequest from "../common/api-request";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import { CircularProgress } from "@material-ui/core";
import debounce from "lodash.debounce";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
    padding: theme.spacing(1, 1),
  },
  paper: {
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(1),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const ResetPassword = (props) => {
  const [notificationMsg,setNotificationMsg] = useState("")
  const [notificationCode,setNotificationCode] = useState("")
  const [displayMsg,setDisplayMsg] = useState(false);
  const handledisplayMsg = ()=> setDisplayMsg(!displayMsg);

  const [submitting,setSubmitting] = useState(false)

  const classes = useStyles();
  const history = useHistory();
  const { 
    handleBackToLogin, 
    action, 
    resetpasswordtoken, 
    resetpassworduidb, } =
    props;

  const initialState = {
    displaySnackBar: false,
    snackBarMessage: "",
    snackBarautoHideDuration: parseInt(
      process.env.REACT_APP_NOTIFICATION_TIME_OUT
    ),

    snackBarVerticalPosition: "top",
    snackBarHorizontalPosition: "right",
    snackBarSeverity: "info",
    loading: false,
    email: "",
    password: "",
    password2: "",
  };

  const [state, setState] = useState(initialState);

  const {
    displaySnackBar,
    snackBarMessage,
    snackBarautoHideDuration,
    snackBarVerticalPosition,
    snackBarHorizontalPosition,
    snackBarSeverity,
    loading,
    email,
    password,
    password2,
    updatePassword,
  } = state;

  const handleSubmit = async () => {
    setNotificationMsg("");
    setNotificationCode("");
    setDisplayMsg(false);

    setSubmitting(true);


    if (action === `Reset password`){
      await makeApiRequest({
        uri: `/users/request-reset-email/`,
        dataName: `addedUser`,
        method: `post`,
        data: {
          email,
        },
      });
    }

    if (action === `Key in new password`)
      await makeApiRequest({
        uri: `/users/password-reset/`,
        dataName: `updatedUser`,
        method: `post`,
        data: {
          uidb64: resetpassworduidb,
          token: resetpasswordtoken,
          password,
        },
      });      
  };

  const handleLoader = (action) => {
    setState((prevState) => ({
      ...prevState,
      loading: action,
    }));
  };

  const handleChangeUrl = () => {
    const baseUrl = window.location.origin; // Get the base URL
    history.push(baseUrl); // Change the URL without reloading
  };

  const showNotification = debounce((msg, severity,status) => {
    
    if (severity.toLowerCase() === "error" && msg?.search("401") !== -1) {
      return;
    }
    // if (severity.toLowerCase() === "error" && msg?.search("404") !== -1) {
    //   return;
    // }
    setState((prevState) => ({
      ...prevState,
      displaySnackBar: true,
      snackBarMessage: msg,
      snackBarSeverity: severity,
    }));
  }, 300);

  const handleApiData = (params) => {
    
    const { data, severity, status } = params;
    let snackBarMessage = "Success.";
    if (severity === "error") {
      snackBarMessage = data;
      // 
      if(action === `Key in new password` && status === 404){   
        handleBackToLogin();   
        history.push("/");
      }else{
        setNotificationMsg(data);
        setNotificationCode("error")
        handledisplayMsg();
        setSubmitting(false);
      }
    }

    if (severity === "success") {
      setState((prevState) => ({
        ...prevState,
        email: "",
        password: "",
        password2: "",
      }));


      console.log(action)
      console.log(params)
      
      if(action === `Reset password`){
        setNotificationMsg("Reset password link has been sent to your email address and SMS. Follow intructions to reset password");
        setNotificationCode("success");
        handledisplayMsg();
      }

      if(action === `Key in new password` && status == 200){
        setNotificationMsg("Password changed successfully. You will be redirected to login page");
        setNotificationCode("success");
        setDisplayMsg(true);
        handledisplayMsg(); 
        setTimeout(() => {
          handleBackToLogin();   
          history.push("/");
        }, 10000); 
        setNotificationMsg("");
        setNotificationCode("");
        setDisplayMsg(false);
      }
    }

    setSubmitting(false);
    showNotification(snackBarMessage, severity, status);
  };

  const makeApiRequest = async (params) => {
    const { uri, dataName, method, data } = params;
    const requestParams = {
      handleLoader,
      url: `${process.env.REACT_APP_API_URL}${uri}`,
      data,
      callBack: handleApiData,
      method,
      dataName,
    };
    await apiRequest(requestParams);
  };

  const checkPassword = Password.validate(password) && password === password2;

  const isValidData =
    action === `Reset password`
      ? Email.validate(email)
      : action === `Key in new password`
      ? checkPassword
      : false;

  const handleInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setNotificationMsg("");
    setNotificationCode("");
    setDisplayMsg(false);

    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };



  return (
    <div className={classes.root}>
      <Dialog
        open={!(action.search("password") === -1)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress />
          </Backdrop>
          <Snackbar
            anchorOrigin={{
              vertical: snackBarVerticalPosition,
              horizontal: snackBarHorizontalPosition,
            }}
            open={displaySnackBar}
            autoHideDuration={snackBarautoHideDuration}
            onClose={() => {
              setState((prevState) => ({
                ...prevState,
                displaySnackBar: false,
              }));
            }}
            // message={snackBarMessage}
          >
            <Alert severity={snackBarSeverity}>{snackBarMessage}</Alert>
          </Snackbar>
          <Grid container justify="flex-end">
            <IconButton onClick={() => handleBackToLogin(`Close`)}>
              <CloseIcon style={{ fill: "red" }} />
            </IconButton>
          </Grid>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid item xs>
              <Grid container spacing={2}>
                <Grid item xs>
                  <b>{action}</b>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <div className={classes.root}>
            {action === "Reset password" && (
              <Grid container spacing={3}>
                <Grid item xs>
                  <TextField
                    error={!Email.validate(email)}
                    helperText={
                      !Email.validate(email) ? "Valid email required." : ""
                    }
                    margin="dense"
                    name="email"
                    id="email"
                    label="Email"
                    type="text"
                    onChange={handleInput}
                    value={email ?? ""}
                    fullWidth
                    required
                  />
                  {displayMsg &&
                    <span 
                      style={{ 
                                marginTop:"5px",
                                color: `${notificationCode === "success" ? "green" : notificationCode === "error" && "red" }`
                            }}
                    > 
                      {notificationMsg}
                    </span>
                  }
                </Grid>
              </Grid>
            )}

            {action === "Key in new password" && (
              <Grid container spacing={3}>

                <Grid item xs={6}>
                  <TextField
                    error={!Password.validate(password)}
                    helperText={
                      !Password.validate(password)
                        ? "Password must be, length 8 - 100, at least one special character, uppercase letter, lowercase letter, 2 digits and no spaces."
                        : ""
                    }
                    margin="dense"
                    name="password"
                    id="password"
                    label="Password"
                    type="password"
                    onChange={handleInput}
                    value={password ?? ""}
                    fullWidth
                    required
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    error={
                      !Password.validate(password2) || !(password === password2)
                    }
                    helperText={
                      !Password.validate(password2) || !(password === password2)
                        ? "Required, must match the first password."
                        : ""
                    }
                    margin="dense"
                    name="password2"
                    id="password2"
                    label="Retype Password"
                    type="password"
                    onChange={handleInput}
                    value={password2 ?? ""}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  {displayMsg &&
                    <span 
                      style={{ 
                                marginTop:"5px",
                                color: `${notificationCode === "success" ? "green" : notificationCode === "error" && "red" }`
                            }}
                    > 
                      {notificationMsg}
                    </span>
                  }
                </Grid>

              </Grid>
            )}

          </div>
        </DialogContent>

        <DialogActions>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid item xs>
              <Grid container spacing={2}>
                <Grid item xs>
                  <Button
                    onClick={() => {
                      handleBackToLogin({ fetch: false });
                    }}
                    color="primary"
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs>
                  <Button
                    onClick={() => {
                      handleSubmit();
                    }}
                    color="primary"
                    variant="outlined"
                    disabled={!isValidData}
                  >
                    {submitting ? "Saving..." : "Submit"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogActions>

      </Dialog>
    </div>
  );
};
export default ResetPassword;
